"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandsExecutor = void 0;
var core_1 = require("@athena-portal/core");
var journey_services_1 = require("@athena-portal/journey-services");
var journey_services_2 = require("@athena-portal/journey-services");
var Types_1 = require("../../Types");
var uuid_1 = require("uuid");
var CommandsExecutor = exports.CommandsExecutor = /** @class */ (function () {
    function CommandsExecutor() {
    }
    CommandsExecutor.prototype.executeNativeEvent = function (nativeEvent, context) {
        return __awaiter(this, void 0, void 0, function () {
            var commands;
            return __generator(this, function (_a) {
                commands = this.fetchCommandsByNativeControlEvent(nativeEvent, context.question);
                if (commands) {
                    return [2 /*return*/, this.executeCommands(nativeEvent, commands, context)];
                }
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    CommandsExecutor.prototype.executeEvent = function (eventType, context) {
        return __awaiter(this, void 0, void 0, function () {
            var event, commands;
            return __generator(this, function (_a) {
                event = { type: eventType };
                commands = this.fetchCommandsByNativeControlEvent(event, context.question);
                if (commands) {
                    return [2 /*return*/, this.executeCommands(event, commands, context)];
                }
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    CommandsExecutor.prototype.executeNativePageEvent = function (nativeEvent, context) {
        return __awaiter(this, void 0, void 0, function () {
            var commands;
            return __generator(this, function (_a) {
                commands = this.fetchCommandsByNativePageEvent(nativeEvent, context.page);
                if (commands) {
                    return [2 /*return*/, this.executeCommands(nativeEvent, commands, context)];
                }
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    CommandsExecutor.prototype.executePageEvent = function (eventType, context) {
        return __awaiter(this, void 0, void 0, function () {
            var event, commands;
            return __generator(this, function (_a) {
                event = { type: eventType };
                commands = this.fetchCommandsByNativePageEvent(event, context.page);
                if (commands) {
                    return [2 /*return*/, this.executeCommands(event, commands, context)];
                }
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    CommandsExecutor.prototype.executeJourneyEvent = function (eventType, context) {
        return __awaiter(this, void 0, void 0, function () {
            var commands;
            return __generator(this, function (_a) {
                commands = this.fetchCommandsByJourneyEvent(eventType, context.journey);
                if (commands) {
                    return [2 /*return*/, this.executeCommands({ type: eventType }, commands, context)];
                }
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    CommandsExecutor.prototype.executeValidationEvent = function (eventType, context) {
        return __awaiter(this, void 0, void 0, function () {
            var commands;
            return __generator(this, function (_a) {
                commands = this.fetchCommandsByValidationEvent({ type: eventType }, context.validation);
                if (commands) {
                    return [2 /*return*/, this.executeCommands({ type: eventType }, commands, context)];
                }
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    CommandsExecutor.prototype.executeCommands = function (nativeEvent, commands, context) {
        return __awaiter(this, void 0, void 0, function () {
            var com, eventId, _i, _a, eventDefinition, commandDefinition, props, command, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        eventId = (0, uuid_1.v4)();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 9, 10]);
                        commands.showOverlay && context.engine.toggleOverlay(true, eventId);
                        _i = 0, _a = commands.commands;
                        _b.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        eventDefinition = _a[_i];
                        com = eventDefinition;
                        commandDefinition = this.journeyComponentsManager.fetchCommand(eventDefinition.type);
                        if (!commandDefinition) return [3 /*break*/, 4];
                        if (this.isExecutable(eventDefinition, context, context.engine.getInteraction()) === false) {
                            return [3 /*break*/, 4];
                        }
                        props = __assign(__assign({}, context), { updateInteraction: function (value, dotNotation) {
                                if (dotNotation) {
                                    var newInt = __assign({}, context.engine.getInteraction());
                                    journey_services_1.ObjectManipulator.setField(dotNotation, newInt, value);
                                    context.engine.callInteractionSetState(newInt);
                                }
                                else {
                                    context.engine.callInteractionSetState(value);
                                }
                            }, event: nativeEvent, journeyEventDefinition: eventDefinition });
                        command = new commandDefinition.component();
                        return [4 /*yield*/, command.exec(props)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 10];
                    case 6:
                        error_1 = _b.sent();
                        this.journeyRuntimeService.doBackendAction("log", context.engine.getInteraction(), {
                            level: "ERROR",
                            message: "JRE: Command execution exception: ".concat(error_1 && error_1.error || "", " ").concat(error_1 && error_1.message || "", "\n    Interaction id: ").concat(context.interaction._id || "-", "\n    Product: ").concat(context.product || "-", "\n    Process: ").concat(context.process || "-", "\n    Event: ").concat(nativeEvent.type || "-", "\n    Command: ").concat(com !== undefined ? com.type : "-", "\n    Page: ").concat(context.page ? context.page.pageId : "-", "\n    Stack: ").concat(error_1 && error_1.stack || "-", "\n    Error: ").concat(error_1 ? core_1.JsonUtils.errorToString(error_1) : "-")
                        }, false).subscribe();
                        if (!context.journey.errorPageId) return [3 /*break*/, 8];
                        return [4 /*yield*/, context.engine.navigate(context.journey.errorPageId, false, false)];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8: throw new Error("Command execution exception: ".concat(error_1 && error_1.error || ""));
                    case 9:
                        commands.showOverlay && context.engine.toggleOverlay(false, eventId);
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    CommandsExecutor.prototype.fetchCommandsByNativePageEvent = function (nativeEvent, page) {
        if (page && page.events) {
            switch (nativeEvent.type) {
                case "onLoad":
                    return page.events.onLoad;
                case "onBeforeValidate":
                    return page.events.onBeforeValidate;
                case "onAfterValidate":
                    return page.events.onAfterValidate;
                case "onBeforeMoveBack":
                    return page.events.onBeforeMoveBack;
                case "onBeforeMoveNext":
                    return page.events.onBeforeMoveNext;
                case "keydown":
                    return page.events.onKeyDown;
                case "submit":
                    return page.events.onSubmit;
                default:
                    throw new Error("Native event of type \"".concat(nativeEvent.type, "\" not supported."));
            }
        }
        return undefined;
    };
    CommandsExecutor.prototype.fetchCommandsByValidationEvent = function (nativeEvent, validation) {
        if (validation && validation.events) {
            switch (nativeEvent.type) {
                case "onValidateSuccess":
                    return validation.events.onValidateSuccess;
                case "onValidateFail":
                    return validation.events.onValidateFail;
                default:
                    throw new Error("Validation event of type \"".concat(nativeEvent.type, "\" not supported."));
            }
        }
        return undefined;
    };
    CommandsExecutor.prototype.fetchCommandsByNativeControlEvent = function (nativeEvent, question) {
        if (question.events) {
            switch (nativeEvent.type) {
                case "click":
                    return question.events.onClick;
                case "dblclick":
                    return question.events.onDoubleClick;
                case "focus":
                    return question.events.onFocus;
                case "blur":
                    return question.events.onBlur;
                case "change":
                    return question.events.onChange;
                case "onValidateSuccess":
                    return question.events.onValidateSuccess;
                case "onValidateFail":
                    return question.events.onValidateFail;
                default:
                    throw new Error("Native event of type \"".concat(nativeEvent.type, "\" not supported."));
            }
        }
        return undefined;
    };
    CommandsExecutor.prototype.fetchCommandsByJourneyEvent = function (event, journey) {
        if (journey && journey.events) {
            return journey.events[event];
        }
        return undefined;
    };
    /**
     * Evaluates command DC
     * @param eventDefinition
     * @param context
     * @param updatedInteraction incase previous command(s) update interaction
     */
    CommandsExecutor.prototype.isExecutable = function (eventDefinition, context, updatedInteraction) {
        return !eventDefinition.condition || (eventDefinition.condition !== undefined &&
            journey_services_2.ConditionEvaluator.evaluateCondition(context.journey.displayConditions, eventDefinition.condition, updatedInteraction));
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.JourneyComponentsManager),
        __metadata("design:type", Object)
    ], CommandsExecutor.prototype, "journeyComponentsManager", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], CommandsExecutor.prototype, "journeyRuntimeService", void 0);
    CommandsExecutor = __decorate([
        (0, core_1.injectable)()
    ], CommandsExecutor);
    return CommandsExecutor;
}());
//# sourceMappingURL=CommandsExecutor.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/services/impl/CommandsExecutor.js
// module id = 2273
// module chunks = 0